 var swiper = new Swiper('.mySwiperblog', {
    slidesPerView: 1,
    spaceBetween: 10,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    breakpoints: {
      700: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  });